musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
// musicManager.inGamble = false;
musicManager.wasInFreeSpins = false;
musicManager.inBaseGameModifier = false;
musicManager.musicLevel = 1;

// musicManager.freeSpinsIntroLoop = undefined;
// musicManager.freeSpinsIntroLoopMaxVolume = 0.6;

musicManager.ALLOFFLEVEL = [false, false, false];
musicManager.IDLELEVEL = [true, false, false];
musicManager.SPINLEVEL = [false, true, false];
musicManager.SINGLEWINLEVEL = [false, false, true];

musicManager.FREESPINS_ALLOFF = [false];
musicManager.FREESPINS_BASE = [true];

musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.steppingDown = false;

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

// musicManager.devilFrustratedSounds = [
//   "devilNegative1",
//   "devilNegative2",
//   "devilNegative3",
//   "devilNegative4",
// ];

musicManager.devilPositiveSounds = ["devilPositive1", "devilPositive2", "devilPositive3"];

musicManager.devilLaughSounds = ["devilLaugh1", "devilLaugh2", "devilLaugh3", "devilLaugh4"];

musicManager.devilCheerSounds = ["devilCheer1", "devilCheer2", "devilCheer3", "devilCheer4"];

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 2.5;
  musicManager.fadeBaseTimeOut = 3;

  musicManager.fadeBigWinTimeIn = 0.2;
  musicManager.fadeBigWinTimeOut = 0.2;

  musicManager.maxMusicVolume = 0.56;
  musicManager.loweredMusicVolume = 0.3;

  musicManager.stepDownTimer = undefined;
  musicManager.stepDownDuration = 10000;

  musicManager.baseID = [];
  musicManager.freeSpinsID = [];
  musicManager.respinsMusicID = undefined;
  // musicManager.gambleID = [];

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.baseMusic = ["gameTheme0", "gameTheme1", "gameTheme2"];
  musicManager.freeSpinsMusic = ["freeSpinsLoop1"];
  // musicManager.gambleMusic = ["gameTheme3", "maxPlayLoop3"];

  musicManager.basePlaying = musicManager.ALLOFFLEVEL;
  musicManager.fsPlaying = musicManager.FREESPINS_ALLOFF;

  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.getRandomSoundFromArray = function (arr) {
  const randIndex = Math.floor(Math.random() * arr.length);
  return arr[randIndex];
};

musicManager.playDevilPositiveSound = function () {
  soundManager.play(musicManager.getRandomSoundFromArray(musicManager.devilPositiveSounds));
};

musicManager.playDevilLaughSound = function () {
  soundManager.play(musicManager.getRandomSoundFromArray(musicManager.devilLaughSounds));
};

musicManager.playDevilCheerSound = function () {
  soundManager.play(musicManager.getRandomSoundFromArray(musicManager.devilCheerSounds));
};

musicManager.playChestExpandSound = function (index) {
  if (index > 4) {
    index = 4;
  }
  soundManager.play(`chestExpand${index}`);
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(soundManager.play(musicManager.freeSpinsMusic[j]));
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  musicManager.respinsMusicID = soundManager.play("respinsTheme");
  soundManager.setVolume(0, musicManager.respinsMusicID);

  // // setup gamble music tracks - all volumes 0
  // for (var j = 0; j < musicManager.gambleMusic.length; j++) {
  //   musicManager.gambleID.push(soundManager.play(musicManager.gambleMusic[j]));
  //   soundManager.setVolume(0, musicManager.gambleID[j]);
  // }

  // musicManager.fadeLevels(
  //   musicManager.IDLELEVEL,
  //   musicManager.fadeBaseTimeIn,
  //   musicManager.fadeBaseTimeOut
  // );
};

musicManager.onGameIntro = function () {
  soundManager.play("gameIntro");
  timerManager.addTimeout(3000, () => {
    musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  });
};

musicManager.unlockIntroComplete = function () {
  musicManager.playDevilLaughSound();
};

musicManager.onGameStart = function () {
  musicManager.steppingDown = true;

  if (musicManager.basePlaying != musicManager.SINGLEWINLEVEL) {
    musicManager.steppingDown = false;
    timerManager.stop(musicManager.stepDownTimer);
  }

  musicManager.idle = false;

  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;

    if (musicManager.basePlaying === musicManager.IDLELEVEL) {
      musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
    }
  }
};

musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;

  if (!musicManager.steppingDown) {
    timerManager.stop(musicManager.stepDownTimer);
    musicManager.stepDownTimer = timerManager.addTimeout(musicManager.stepDownDuration, () => {
      musicManager.stepDown();
    });
  }
};

musicManager.stepUp = function () {
  if (musicManager.inFreespins) return;

  timerManager.stop(musicManager.stepDownTimer);

  if (musicManager.basePlaying == musicManager.SPINLEVEL) {
    musicManager.fadeLevels(musicManager.SINGLEWINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.stepDown = function () {
  switch (musicManager.basePlaying) {
    case musicManager.SINGLEWINLEVEL:
      musicManager.stepDownTimer = timerManager.addTimeout(musicManager.stepDownDuration, () => {
        musicManager.stepDown();
      });
      musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
      break;
    case musicManager.SPINLEVEL:
      timerManager.stop(musicManager.stepDownTimer);
      musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
      break;
  }
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play("bigWinLoop");

  timerManager.stop(musicManager.stepDownTimer);

  // soundManager.fade(
  //   0,
  //   musicManager.fadeBigWinTimeOut,
  //   musicManager.gambleID[0]
  // );
  // soundManager.fade(
  //   0,
  //   musicManager.fadeBigWinTimeOut,
  //   musicManager.gambleID[1]
  // );
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBigWinTimeIn, musicManager.fadeBigWinTimeOut);
  }
};

musicManager.onBigWinEnd = function () {
  timerManager.stop(musicManager.stepDownTimer);
  soundManager.stop("coinLoop");
  soundManager.stop("bigWinLoop");
  soundManager.play("bigWinEnd");

  timerManager.addTimeout(3000, () => {
    musicManager.fadeLevels(musicManager.IDLELEVEL, 1.5, 0.5);
    musicManager.stepDownTimer = timerManager.addTimeout(musicManager.stepDownDuration, () => {
      musicManager.stepDown();
    });
  });

  musicManager.inFreespins = false;
  musicManager.wasInFreeSpins = true;
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime) {
  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeIn[i], undefined);
  }

  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOut[i], undefined);
  }

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeInFS[i], undefined);
  }

  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fsPlaying = levels;
};

musicManager.gambleEnter = function () {
  // if (musicManager.inFreespins) return;
  // if (musicManager.inGamble) return;
  // musicManager.inGamble = true;
  // soundManager.fade(musicManager.freeSpinsIntroLoopMaxVolume, 1.5, musicManager.gambleID[0]);
  // musicManager.fadeLevels(musicManager.ALLOFFLEVEL, 1, 1);
};

musicManager.gambleExit = function () {
  // musicManager.inGamble = false;
  // soundManager.fade(0, 1.5, musicManager.gambleID[0]);
  // musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.gambleSpin = function () {
  // soundManager.play("gambleStart");
  // soundManager.play("gambleSpin");
  // soundManager.fade(0.1, 0.5, musicManager.gambleID[0]);
};

musicManager.gambleLand = function () {
  // soundManager.fade(musicManager.freeSpinsIntroLoopMaxVolume, 2, musicManager.gambleID[0]);
};

musicManager.hookStart = function () {
  // soundManager.play("hookMusic");
  // soundManager.play("hookSound");
  // musicManager.fadeLevels(musicManager.ALLOFFLEVEL, 0.5, 0.5);
};

musicManager.hookEnd = function () {
  // musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onFreeSpinsIntro = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, 0.5);
  musicManager.playing = false;

  soundManager.play("freeSpinsIntroWait");
};

musicManager.onFreeSpinsStart = function () {
  soundManager.stop("freeSpinsIntroWait");

  timerManager.stop(musicManager.stepDownTimer);

  musicManager.fadeFSLevels(musicManager.FREESPINS_BASE, 1.5, 0.5);
  musicManager.inFreespins = true;
};

musicManager.setFreeSpinsLevel = function (level) {
  // let before = musicManager.freeSpinsLevel;
  // switch (level) {
  //   case 0:
  //     musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
  //     break;
  //   case 1:
  //     musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
  //     break;
  //   case 2:
  //     musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
  //     break;
  //   case 3:
  //     musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL2;
  //     break;
  // }
  // if (before != musicManager.freeSpinsLevel) {
  //   musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  // }
};

musicManager.onFreeSpinsOutro = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;
  musicManager.fadeFSLevels(musicManager.FREESPINS_ALLOFF, musicManager.fadeBaseTimeIn, 0.5);
  musicManager.playing = false;

  soundManager.play("freeSpinsOutro");
  musicManager.fsOutroTimer = timerManager.addTimeout(4000, () => {
    musicManager.onFreeSpinsEnd();
  });
};

musicManager.onFreeSpinsEnd = function () {
  if (musicManager.isSoundPlaying("freeSpinsOutro")) {
    soundManager.stop("freeSpinsOutro");
  }

  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(musicManager.IDLELEVEL, 1.5, 0.5);
  musicManager.stepDownTimer = timerManager.addTimeout(musicManager.stepDownDuration, () => {
    musicManager.stepDown();
  });

  musicManager.inFreespins = false;
  musicManager.wasInFreeSpins = true;
};

musicManager.onRespinsStart = function () {
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(musicManager.FREESPINS_ALLOFF, musicManager.fadeBaseTimeIn, 0.5);
  } else {
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, 0.5);
  }

  soundManager.fade(musicManager.maxMusicVolume, 1.5, musicManager.respinsMusicID, undefined);
};

musicManager.onRespinsEnd = function () {
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(musicManager.FREESPINS_BASE, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else {
    musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
  soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.respinsMusicID, undefined);
};

musicManager.onPlayBubbleIntro = function () {
  // const bubbleIntroSound = soundManager.play("bubblesIntro");
  // timerManager.addTimeout(2200, function () {
  //   soundManager.fade(0, 0.5, bubbleIntroSound);
  // });
};

musicManager.popupEnter = function () {
  musicManager.changeMusicVolume(musicManager.loweredMusicVolume);
  soundManager.play("popupIn");
  timerManager.addTimeout(2000, () => {
    musicManager.changeMusicVolume(musicManager.maxMusicVolume, 1.5);
  });
};

musicManager.popupExit = function () {
  musicManager.changeMusicVolume(musicManager.loweredMusicVolume);
  soundManager.play("popupOut");
  timerManager.addTimeout(2000, () => {
    musicManager.changeMusicVolume(musicManager.maxMusicVolume, 1.5);
  });
};

musicManager.changeMusicVolume = function (newVolume, changeDuration = 0.3) {
  if (musicManager.currentMusicVolume !== newVolume) {
    musicManager.currentMusicVolume = newVolume;

    if (gameController.isRespinning) {
      soundManager.fade(newVolume, changeDuration, gameController.respinsMusicID);
    } else {
      const musicPlaying = musicManager.inFreespins ? musicManager.fsPlaying : musicManager.basePlaying;
      const musicIds = musicManager.inFreespins ? musicManager.freeSpinsID : musicManager.baseID;
      musicPlaying.forEach((music, index) => {
        if (music) soundManager.fade(newVolume, changeDuration, musicIds[index]);
      });
    }
  }
};

musicManager.returnToIdle = function () {
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.isSoundPlaying = function (tag) {
  if (soundManager.soundsConfig.tags[tag] != null) {
    return soundManager.isSoundPlaying(soundManager.soundsConfig.tags[tag].filename);
  }
  return false;
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === "back from replay" && !Reflex.replayGame) {
    musicManager.baseID = [];
    musicManager.freeSpinsID = [];
    musicManager.respinsMusicID = undefined;
    musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;
    musicManager.basePlaying = musicManager.ALLOFFLEVEL;
    musicManager.fsPlaying = musicManager.FREESPINS_ALLOFF;
    musicManager.previouslyPlayingBeforeFade = [];

    musicManager.onGameLoaded();
    musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.update = function () {};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);

messageBus.subscribe("sounds:restorePreviouslyPlayingAudio", musicManager.onRestorePreviouslyPlayingAudio);
